import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const identityRegisterRequestSource = 'identityRegister';
export const identityRegisterDocument = /* GraphQL */ `
    mutation IdentityRegister($formFields: SignUpFormFields!) {
        identityRegister(formFields: $formFields) {
            success
            userId
            message
            errorCode
            fieldErrors {
                field
                message
            }
        }
    }
`;
export const identityRegisterMutation = graphql(identityRegisterDocument);
